// Generated from assets/icons/tab-bar-folder-active.svg (TA-11013).
// Ids are derived per instance via useSvgIdPrefix() so two copies on one
// screen cannot collide. Edit this file rather than re-adding the .svg.
import * as React from 'react';
import Svg, { Path, Defs, LinearGradient, Stop } from 'react-native-svg';

import { useSvgIdPrefix } from '@hooks/useSvgIdPrefix';

import type { SvgProps } from 'react-native-svg';

export const TabBarFolderActive = (props: SvgProps) => {
  const uid = useSvgIdPrefix();
  return (
    <Svg width={24} height={24} fill='none' viewBox='0 0 24 24' {...props}>
      <Path
        fill={`url(#${uid}-a)`}
        d='M2.45 15.977V6.243A3.243 3.243 0 0 1 5.693 3h3.135a2.7 2.7 0 0 1 1.912.791l1.71 1.71h5.676a4.324 4.324 0 0 1 4.324 4.325v6.151a4.324 4.324 0 0 1-4.324 4.325H6.774a4.325 4.325 0 0 1-4.324-4.325'
      />
      <Defs>
        <LinearGradient
          id={`${uid}-a`}
          x1={5.95}
          x2={24.236}
          y1={5.163}
          y2={27.284}
          gradientUnits='userSpaceOnUse'>
          <Stop stopColor='#97D8C6' />
          <Stop offset={1} stopColor='#32866F' />
        </LinearGradient>
      </Defs>
    </Svg>
  );
};
